import { SelectionModel } from '@angular/cdk/collections';
import { Component, ContentChild, EventEmitter, Input, OnInit, Output, SimpleChanges, TemplateRef, ViewChild } from '@angular/core';
import { PageEvent, MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { debounceTime, Subject } from 'rxjs';
import { IColumnConfigTableResponsive } from 'src/app/domain/IColumnConfigTableResponsive';
import { FieldTypeEnum } from 'src/app/domain/registration/enums/field-type.enum';
import { TypeIndexEnum } from 'src/app/domain/registration/enums/type-index.enum';
import { KeyboardService } from 'src/app/shared/components/keyboard/keyboard.service';
import { GlobalUtils } from 'src/app/shared/global-utils';
import { S3_URL_BASE } from 'src/environments/environment';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { IEvents } from 'src/app/domain/registration/models/IEvents';
import { PeriodicElement } from 'src/app/views/registration/user-group-permissions/user-group-permissions.component';

@Component({
  selector: 'app-faq-table',
  templateUrl: './faq-table.component.html',
  styleUrls: ['./faq-table.component.sass'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({height: '0px', minHeight: '0'})),
      state('expanded', style({height: '*'})),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class FaqTableComponent implements OnInit {
  @ContentChild(TemplateRef)
  templateRef : TemplateRef<any>;

  // columnsToDisplayWithExpand = [...this.columnsToDisplay, 'expand'];
  expandedElement: PeriodicElement | null;

  constructor(
    public keyboardService: KeyboardService,
    private dialog: MatDialog,
    private router: Router,

  ) {}

  @Input() hasFilter: boolean = true;
  @Input() lockProperty: string = '';
  @Input() activeProperty: string = '';
  @Input() lockPeopleProperty: string = '';
  @Input() showLock: boolean = false;
  @Input() showActive: boolean = false;
  @Input() showPeopleLock: boolean = false;
  @Input() showKey: boolean = false;
  @Input() showQrCode: boolean = false;
  @Input() hasAdd: boolean = true;
  @Input() type: TypeIndexEnum = TypeIndexEnum.CRUD;
  @Input() length: number = 0;
  @Output() changePage: EventEmitter<any> = new EventEmitter<any>();
  @Output() filter: EventEmitter<any> = new EventEmitter<any>();
  @Output() onSelect: EventEmitter<any> = new EventEmitter<any>();
  @Output() onSelectionChange: EventEmitter<any> = new EventEmitter<any>();

  keyboardChange: EventEmitter<any> = new EventEmitter<any>();
  filterValue: string = '';

  pageSize = 10;
  pageSizeOptions: number[] = [5, 10, 25, 100];
  selection = new SelectionModel<any>(true, []);

  ngOnInit(): void {
    this.keyboardChange.subscribe((event) => {
      this.applyFilter(event);
    });

    this.filterSubject.pipe(debounceTime(500)).subscribe((value) => {
      this.filter.emit(value?.toUpperCase());
    });
  }

  public pageEvent(event: PageEvent): PageEvent {
    this.changePage.emit({ page: event.pageIndex, limit: event.pageSize });
    return event;
  }

  setPageSizeOptions(setPageSizeOptionsInput: string) {
    if (setPageSizeOptionsInput) {
      this.pageSizeOptions = setPageSizeOptionsInput
        .split(',')
        .map((str) => +str);
    }
  }

  @ViewChild(MatPaginator)
  paginator!: MatPaginator;
  @ViewChild(MatSort)
  sort: MatSort = new MatSort();

  @Input('hideFilter') hideFilter: boolean;
  @Input('hidePagination') hidePagination: boolean;
  @Input('displayedColumns')
  displayedColumns: string[];
  @Input('displayedColumnsOnDetail')
  displayedColumnsOnDetail: string[];
  @Input('dataSource')
  dataSource: MatTableDataSource<any>;
  @Input('configColumns')
  configColumns: IColumnConfigTableResponsive[];

  @Output() openShow: EventEmitter<any> = new EventEmitter();
  @Output() openResponseDialog: EventEmitter<any> = new EventEmitter();
  @Output() openNew: EventEmitter<any> = new EventEmitter();
  @Output() openEdit: EventEmitter<any> = new EventEmitter();
  @Output() openDelete: EventEmitter<any> = new EventEmitter();
  @Output() openQrcode: EventEmitter<any> = new EventEmitter();
  @Output() lock: EventEmitter<any> = new EventEmitter();
  @Output() unlock: EventEmitter<any> = new EventEmitter();
  @Output() active: EventEmitter<any> = new EventEmitter();
  @Output() inactive: EventEmitter<any> = new EventEmitter();
  @Output() lockPeople: EventEmitter<any> = new EventEmitter();
  @Output() unlockPeople: EventEmitter<any> = new EventEmitter();
  @Output() key: EventEmitter<any> = new EventEmitter();

  @Input()
  totalizers: {
    selectTotal: number;
    registrationTotal: number;
    activeTotal: number;
    deactiveTotal: number;
    lockTotal: number;
  } = {
    selectTotal: 0,
    registrationTotal: 0,
    activeTotal: 0,
    deactiveTotal: 0,
    lockTotal: 0,
  };

  private filterSubject = new Subject<string>();

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
    this.selection.changed.subscribe((items) => {
      this.totalizers.selectTotal = this.selection.selected.length;
      this.onSelectionChange.emit(items);
    });
  }

   ngOnChanges(changes: SimpleChanges): void {
      if (this.dataSource) {
        this.dataSource.sort = this.sort;
      }
   }
  
  applyFilter(value: string) {
    this.filterSubject.next(value);
  }

  get typeIndexEnum() {
    return TypeIndexEnum;
  }

  get fieldTypeEnum() {
    return FieldTypeEnum;
  }

  public getUrl(value: string) {
    return `${S3_URL_BASE}${value}`;
  }

  responseRow(element: any, row: any) {
    element.idx = row;
    this.openResponseDialog.emit(element);
  }

  showRow(element: any, row: any) {
    element.idx = row;
    this.openShow.emit(element);
  }

  editRow(element: any, row: any) {
    element.idx = row;
    this.openEdit.emit(element);
  }

  deleteRow(element: any, row: any) {
    element.idx = row;
    this.openDelete.emit(element);
  }

  qrCodeRow(element: any, row: any) {
    element.idx = row;
    this.openQrcode.emit(element);
  }

  getValue(config: IColumnConfigTableResponsive, data: any) {
    return GlobalUtils.getValueByTypeColumnTableResponsive(config, data);
  }
  
  navigateToForm(event: any): void {
    // Lista de campos que devem ser excluídos do formulário
    const excludedFields = ['isActive', 'allowEdit', 'allowDelete', 'qrCode'];
  
    // Filtrar apenas os campos selecionados e válidos
    const selectedFields = Object.keys(event).reduce((fields: any[], key: string) => {
      if ((event[key] === 'sim' || event[key] === true) && !excludedFields.includes(key)) {
        fields.push({
          name: key,
          label: this.mapFieldToLabel(key), 
          type: this.getFieldType(key), 
          required: true,
        });
      }
      return fields;
    }, []);
  
    // Redireciona para a página de resposta do formulário com os campos necessários
    this.router.navigate(['form-event', event.id], { state: { selectedFields } });
  }
  
  
  // Mapeia o nome do campo para um rótulo amigável
  private mapFieldToLabel(fieldName: string): string {
    const labels: { [key: string]: string } = {
      name: 'Nome',
      description: 'Descrição',
      enterprise: 'Empresa',
      telephone: 'Telefone',
      instagram: 'Instagram',
      mail: 'E-mail',
      photo: 'Foto',
      financial: 'Financeiro',
      legal: 'Jurídico',
      consultant: 'Consultor',
      partner: 'Parceiro',
      representative: 'Representante',
      accounting: 'Contabilidade',
      solutions: 'Soluções',
      plans: 'Planos',
      dashboard: 'Painel de Controle',
      support: 'Suporte',
    };
    return labels[fieldName] || fieldName;
  }
  
  // Define o tipo de campo (checkbox ou texto)
  private getFieldType(fieldName: string): string {
    const checkboxFields = [
      'financial',
      'legal',
      'consultant',
      'partner',
      'representative',
      'accounting',
      'solutions',
      'plans',
      'dashboard',
      'support',
    ];
    return checkboxFields.includes(fieldName) ? 'checkbox' : 'text';
  }
  
  // Checkbox
  select(element: any, row: any) {
    element.idx = row;
    this.onSelect.emit(element);
  }

  public onCheckRow($event: MouseEvent, idx?: number) {
    if ($event) $event.stopPropagation();
    this.onSelect.emit($event);
  }

  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }

  toggleAllRows() {
    if (this.isAllSelected()) {
      this.selection.clear();
      return;
    }

    this.selection.select(...this.dataSource.data);
  }

  checkboxLabel(row?: any): string {
    if (!row) {
      return `${this.isAllSelected() ? 'deselect' : 'select'} all`;
    }
    return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${
      row.saleNumber + 1
    }`;
  }

  hasSelectConfig() {
    return this.displayedColumns.some((col) => col === 'select');
  }

  activeShowLockClass(element: any) {
    if (this.showLock) return element[this.activeProperty] ? 'active' : 'inactive';

    return 'active';
  }

}
